@if (isLoading) {
  <exl-citation-brief-placeholder [copies]="getNumOfCopies()" class="content-placeholders">
  </exl-citation-brief-placeholder>
}

@for (project of projects | paginate: paginationConfig; track trackByProject(i, project); let i = $index) {
  <div
    class="margin-bottom-sm"
    >
    <exl-citation-brief
      (actionClick)="onActionClick($event, project, i)"
      [authors]="project.memberResearchers.concat(project.memberOrganizations)"
        [hidden]="
            !profileService.isPublicPage &&
            (!project.visibleInPortal || !project.visibleInProfiles || !project.visibleInCurrentUserPublicProfile)
        "
      [menuActions]="getMenuAction(project)"
      [queryParams]="{ institution: institutionCode }"
      [router]="project.projectUrl"
      [title]="project.name | translateObject"
      [titleHeaderLevel]="3"
      [type]="project.typeCode"
      >
      @if (!project.visibleInCurrentUserPublicProfile && !profileService.isPublicPage) {
        <ng-container
          slot="additional-status-tags"
          >
          <mulo-status-tag [description]="'research.profile.hide.status.hidden.tooltip' | translate">
            {{ 'research.profile.hide.status.hidden' | translate }}
          </mulo-status-tag>
        </ng-container>
      }
      @if (organizationsCodes(project); as organizations) {
        <p class="semibold">
          @for (organization of organizations; track organization; let isLast = $last) {
            <span>
              {{ organization | translate }}{{ isLast ? '' : ', ' }}
            </span>
          }
        </p>
      }
      @if (project.startDate) {
        <span class="additional-data">
          <span>{{ project.startDate | espdateformat }}</span>
          @if (project.extras?.startDateLabel === 'mng.projects.expected.start_date') {
            <span
              class="margin-left-xs"
              >{{ 'research.projects.list.brief.project.date.expected' | translate }}</span
              >
            }
            <span>&ndash;</span>
          </span>
        }
        @if (project.endDate) {
          <span class="additional-data">
            <span>{{ project.endDate | espdateformat }}</span>
            @if (project.extras?.endDateLabel === 'mng.projects.expected.end_date') {
              <span class="margin-left-xs">{{
                'research.projects.list.brief.project.date.expected' | translate
              }}</span>
            }
          </span>
        }
        @if (!profileService.isPublicPage) {
          <div class="visibility">
            @if (!project.visibleInPortal) {
              <mat-icon
                [matTooltip]="'research.visibility.noPortal' | translate"
                class="margin-right-xs"
                muloSvgViewbox
                svgIcon="public-off"
              ></mat-icon>
            }
            @if (!project.visibleInProfiles) {
              <mat-icon
                [matTooltip]="'research.visibility.noProfiles' | translate"
                class="margin-right-xs"
                muloSvgViewbox
                svgIcon="person-off"
              ></mat-icon>
            }
            @if (!project.visibleInPortal && !project.visibleInProfiles) {
              <span>{{
                'research.visibility.noPnP' | translate
              }}</span>
            }
            @if (!project.visibleInPortal && project.visibleInProfiles) {
              <span>{{
                'research.visibility.noPortal' | translate
              }}</span>
            }
            @if (project.visibleInPortal && !project.visibleInProfiles) {
              <span>{{
                'research.visibility.noProfiles' | translate
              }}</span>
            }
          </div>
        }
        @if (project.description | translateObject; as description) {
          <mulo-expandable
            [collapseLabel]="'research.general.showLess' | translate"
            [expandLabel]="'research.general.showMore' | translate"
            [ratio]="3"
            buttonPosition="right"
            >
            <p [innerHTML]="description | htmlSanitize" class="rich-text-reset"></p>
          </mulo-expandable>
        }
      </exl-citation-brief>
    </div>
  }

  <div>
    @if (!isLoading && pagesCount > 1) {
      <esp-discovery-toolbar>
        <slot-toolbar-middle>
          <pagination-template
            #p="paginationApi"
            (pageChange)="pageChange($event)"
            [id]="paginationConfig.id"
            [maxSize]="7"
            >
            <mulo-paging
              [data]="p"
              [directionLinksAsIcons]="media.is('xs')"
              [nextLabel]="'research.search.results.next' | translate"
              [previousLabel]="'research.search.results.previous' | translate"
              [screenReaderJumpLabel]="'research.aria.results.page.jump.button' | translate"
              id="pagination"
            ></mulo-paging>
          </pagination-template>
        </slot-toolbar-middle>
      </esp-discovery-toolbar>
    }
  </div>
